import React, { useState } from 'react';
import './CustomerActivity.css';

const CustomerActivity = ({ data, title }) => {
  const [sortField, setSortField] = useState('total_usage');
  const [sortDirection, setSortDirection] = useState('desc');

  if (!data || data.length === 0) {
    return <div className="no-data">No customer data available</div>;
  }

  const handleSort = (field) => {
    if (sortField === field) {
      setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
    } else {
      setSortField(field);
      setSortDirection('desc');
    }
  };

  const sortedData = [...data].sort((a, b) => {
    const aValue = a[sortField] || 0;
    const bValue = b[sortField] || 0;
    
    if (sortDirection === 'asc') {
      return aValue - bValue;
    } else {
      return bValue - aValue;
    }
  });

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  // Debug: log data to console
  console.log('CustomerActivity data:', data);

  return (
    <div className="customer-activity">
      <div className="activity-table">
        <table>
          <thead>
            <tr>
              <th onClick={() => handleSort('company')} className="sortable">
                Company
                {sortField === 'company' && (
                  <span className="sort-indicator">
                    {sortDirection === 'asc' ? ' ↑' : ' ↓'}
                  </span>
                )}
              </th>
              <th onClick={() => handleSort('unique_users')} className="sortable">
                Users
                {sortField === 'unique_users' && (
                  <span className="sort-indicator">
                    {sortDirection === 'asc' ? ' ↑' : ' ↓'}
                  </span>
                )}
              </th>
              <th onClick={() => handleSort('total_usage')} className="sortable">
                Usage Count
                {sortField === 'total_usage' && (
                  <span className="sort-indicator">
                    {sortDirection === 'asc' ? ' ↑' : ' ↓'}
                  </span>
                )}
              </th>
              <th>Last Activity</th>
            </tr>
          </thead>
          <tbody>
            {sortedData.map((customer, index) => (
              <tr key={index}>
                <td>{customer.company || 'Unknown'}</td>
                <td>{parseInt(customer.unique_users) || 0}</td>
                <td>{(parseInt(customer.total_usage) || 0).toLocaleString()}</td>
                <td>{formatDate(customer.last_activity)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      
      <div className="activity-summary">
        <div className="summary-item">
          <span className="label">Total Companies:</span>
          <span className="value">{data.length}</span>
        </div>
        <div className="summary-item">
          <span className="label">Total Users:</span>
          <span className="value">
            {data.reduce((sum, customer) => sum + (parseInt(customer.unique_users) || 0), 0).toLocaleString()}
          </span>
        </div>
        <div className="summary-item">
          <span className="label">Total Usage:</span>
          <span className="value">
            {data.reduce((sum, customer) => sum + (parseInt(customer.total_usage) || 0), 0).toLocaleString()}
          </span>
        </div>
      </div>
    </div>
  );
};

export default CustomerActivity; 